import mapbox from 'mapbox-gl';

// https://docs.mapbox.com/help/glossary/access-token/
mapbox.accessToken = "pk.eyJ1IjoiY2piYXNzaW4iLCJhIjoiY2lnbnl5M2JlMDBkY21ma284MHpmYjdycSJ9.hCuiySWxJTct7nZvXRsiEQ";

const key = {};

export { mapbox, key };